import { type TargetQueryV4Row } from "../api/target/v4TargetReportByTarget";
import { type GVAdvertisement } from "../../advertising/types";
import { getDashboardTo } from "../../../views/AdvertisingOverview";
import { useFormatTargetText } from "../../../utils/useFormatTargetText";
import { css } from "../../../../styled-system/css";
import { useAppSelector } from "../../../redux/hooks";
import KeywordCell from "../../../components/custom/category/advertisements/KeywordCell";
import TrellisLink from "../../../components/core/basic/TrellisLink";
import { TargetBadges } from "../../../components/custom/category/advertisements/TargetBadges";

type TargetTextCellProps = {
  target: TargetQueryV4Row;
  adsMapping?: Record<string, GVAdvertisement>;
};

export function TargetTextCell({ target, adsMapping }: TargetTextCellProps) {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const formatTargetText = useFormatTargetText();
  const { text, ad_id, refinements } = target;
  const ad = adsMapping && ad_id ? adsMapping[ad_id] : undefined;

  return (
    <div className={css({ paddingLeft: "small", display: "flex", flexDirection: "column", gap: "xsmall" })}>
      <KeywordCell value={formatTargetText(text, { ...refinements, marketPlace })} columnWidth={300} />
      {ad && (
        <TrellisLink
          to={getDashboardTo({ type: "advertisement", id: ad_id })}
          target="_blank"
          className={css({
            paddingRight: "medium",
            textDecoration: "none",
            fontSize: "medium",
            fontWeight: 500,
          })}
        >
          <small>{ad.ad_name}</small>
        </TrellisLink>
      )}
      <TargetBadges target={target} />
    </div>
  );
}
